import { mapActions } from '../reducer';

export const resetPlannedRoutes = () => mapActions.resetPlannedRoutes();
